module.exports = __webpack_public_path__ + "img/store.edda829c.svg";